import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import classnames from "classnames";
import React, { createContext } from "react";
const PREFIX = "ColorPair";
export const classes = {
    root: `${PREFIX}-root`,
    white: `${PREFIX}-white`,
    pearl: `${PREFIX}-pearl`,
    storm: `${PREFIX}-storm`,
    blue100: `${PREFIX}-blue100`,
    magenta100: `${PREFIX}-magenta100`,
    aqua100: `${PREFIX}-aqua100`,
    orange100: `${PREFIX}-orange100`,
    alert: `${PREFIX}-alert`,
    alabaster: `${PREFIX}-alabaster`,
    black: `${PREFIX}-black`,
    charcoal: `${PREFIX}-charcoal`,
    slate: `${PREFIX}-slate`,
    blue800: `${PREFIX}-blue800`,
    blue900: `${PREFIX}-blue900`,
    teal400: `${PREFIX}-teal400`,
    teal500: `${PREFIX}-teal500`,
    magenta400: `${PREFIX}-magenta400`,
    magenta500: `${PREFIX}-magenta500`,
    purple400: `${PREFIX}-purple400`,
    orange500: `${PREFIX}-orange500`,
    error: `${PREFIX}-error`,
    secondary1: `${PREFIX}-secondary1`,
    secondary2: `${PREFIX}-secondary2`,
    secondary3: `${PREFIX}-secondary3`,
    secondary4: `${PREFIX}-secondary4`
};
const Root = styled(Box)(({ theme }) => ({
    backgroundColor: theme.colours.white,
    color: theme.colours.charcoal,
    WebkitPrintColorAdjust: "exact",
    [`&.${classes.white}`]: {
        backgroundColor: theme.colours.white,
        color: theme.colours.charcoal
    },
    [`&.${classes.pearl}`]: {
        backgroundColor: theme.colours.pearl,
        color: theme.colours.charcoal
    },
    [`&.${classes.storm}`]: {
        backgroundColor: theme.colours.storm,
        color: theme.colours.charcoal
    },
    [`&.${classes.blue100}`]: {
        backgroundColor: theme.colours.blue100,
        color: theme.colours.charcoal
    },
    [`&.${classes.magenta100}`]: {
        backgroundColor: theme.colours.magenta100,
        color: theme.colours.charcoal
    },
    [`&.${classes.aqua100}`]: {
        backgroundColor: theme.colours.aqua100,
        color: theme.colours.charcoal
    },
    [`&.${classes.orange100}`]: {
        backgroundColor: theme.colours.orange100,
        color: theme.colours.charcoal
    },
    [`&.${classes.alert}`]: {
        backgroundColor: theme.colours.yellow400,
        color: theme.colours.charcoal
    },
    [`&.${classes.alabaster}`]: {
        backgroundColor: theme.colours.alabaster,
        color: theme.colours.charcoal
    },
    [`&.${classes.black}`]: {
        backgroundColor: theme.colours.black,
        color: theme.colours.white
    },
    [`&.${classes.charcoal}`]: {
        backgroundColor: theme.colours.charcoal,
        color: theme.colours.white
    },
    [`&.${classes.slate}`]: {
        backgroundColor: theme.colours.slate,
        color: theme.colours.white
    },
    [`&.${classes.blue800}`]: {
        backgroundColor: theme.colours.blue800,
        color: theme.colours.white
    },
    [`&.${classes.blue900}`]: {
        backgroundColor: theme.colours.blue900,
        color: theme.colours.white
    },
    [`&.${classes.teal400}`]: {
        backgroundColor: theme.colours.teal400,
        color: theme.colours.white
    },
    [`&.${classes.teal500}`]: {
        backgroundColor: theme.colours.teal500,
        color: theme.colours.white
    },
    [`&.${classes.magenta400}`]: {
        backgroundColor: theme.colours.magenta400,
        color: theme.colours.white
    },
    [`&.${classes.magenta500}`]: {
        backgroundColor: theme.colours.magenta500,
        color: theme.colours.white
    },
    [`&.${classes.purple400}`]: {
        backgroundColor: theme.colours.purple400,
        color: theme.colours.white
    },
    [`&.${classes.orange500}`]: {
        backgroundColor: theme.colours.orange500,
        color: theme.colours.white
    },
    [`&.${classes.error}`]: {
        backgroundColor: theme.colours.error400,
        color: theme.colours.white
    },
    [`&.${classes.secondary1}`]: {
        backgroundColor: theme.colours.secondary1,
        color: theme.colours.white
    },
    [`&.${classes.secondary2}`]: {
        backgroundColor: theme.colours.secondary2,
        color: theme.colours.white
    },
    [`&.${classes.secondary3}`]: {
        backgroundColor: theme.colours.secondary3,
        color: theme.colours.white
    },
    [`&.${classes.secondary4}`]: {
        backgroundColor: theme.colours.secondary4,
        color: theme.colours.white
    }
}));
export const lightColors = [
    "white",
    "alabaster",
    "pearl",
    "storm",
    "blue100",
    "magenta100",
    "aqua100",
    "orange100",
    "alert"
];
export const darkColors = [
    "black",
    "charcoal",
    "slate",
    "blue800",
    "blue900",
    "teal400",
    "teal500",
    "magenta400",
    "magenta500",
    "purple400",
    "orange500",
    "error",
    "secondary1",
    "secondary2",
    "secondary3",
    "secondary4"
];
export const availableColors = [...lightColors, ...darkColors];
export const isDarkColor = (color) => {
    return !!color && darkColors.includes(color);
};
export const ColorPairContext = createContext({});
const ColorPair = React.forwardRef(({ color = "white", className, children, markupComponent: MarkupComponent = "div", ...rest }, ref) => {
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" &&
        !availableColors.includes(color)) {
        // eslint-disable-next-line no-console
        console.warn(`ColorPair: The color ${color} used doesn't exist in the CSS classes. Check there isn't any misalignment between TS and CSS. Available themes are ${availableColors.join(", ")}`);
    }
    return (_jsx(Root, { as: MarkupComponent, 
        /* eslint-disable-next-line security/detect-object-injection */
        className: classnames(className, classes[color]), ref: ref, ...rest, children: _jsx(ColorPairContext.Provider, { value: { type: isDarkColor(color) ? "dark" : "light", color }, children: children }) }));
});
ColorPair.displayName = "ColorPair";
export default ColorPair;
//# sourceMappingURL=data:application/json;base64,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